/**
 * API endpoints for YouTube
 */
export class YoutubeAPI {
    /**
     * Get a YouTube video
     * @param videoId - The video ID
     * @returns Promise with the video
     */
    async getVideo(videoId) {
        return fetch(`https://www.youtube.com/oembed?url=http://www.youtube.com/watch?v=${videoId}&format=json`)
            .then((res) => (res.ok ? res : Promise.reject(res)))
            .then((response) => response.json())
            .catch((error) => {
            console.error("Error:", error);
        });
    }
}
